import { render, staticRenderFns } from "./ProfileAddresses.vue?vue&type=template&id=c07f96fa&scoped=true"
import script from "./ProfileAddresses.vue?vue&type=script&lang=js"
export * from "./ProfileAddresses.vue?vue&type=script&lang=js"
import style0 from "./ProfileAddresses.vue?vue&type=style&index=0&id=c07f96fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07f96fa",
  null
  
)

export default component.exports